<template>
  <v-container fluid class="pa-0">
    <!-- Header with Search and Button -->
    <v-row align="center" justify="space-between" class="mb-4">
      <v-col cols="12" md="6">
        <h2 class="text-h6 font-weight-bold">Programs</h2>
      </v-col>
      <v-col cols="12" md="6" class="d-flex justify-end align-center gap-3">
        <v-text-field
          v-model="search"
          label="Search"
          prepend-inner-icon="mdi-magnify"
          variant="outlined"
          density="compact"
          hide-details
          clearable
          class="mr-2"
          color="primary"
        />
        <v-btn
          :color="$vuetify.theme.themes.light.submitBtnsGreen"
          class="white--text"
          @click="addnew"
          prepend-icon="mdi-plus-box-outline"
          rounded
        >
          Add New
        </v-btn>
        <!-- <v-btn
          color="warning"
          class="white--text mx-1"
          @click="upload"
          prepend-icon="mdi-upload-outline"
          rounded
        >
          Upload
        </v-btn> -->
      </v-col>
    </v-row>

    <!-- Data Table -->
    <v-card elevation="2" class="pa-2">
      <v-data-table
        :headers="headers"
        :items="data"
        :search="search"
        :loading="loading"
        hover
        density="compact"
        class="rounded-lg"
      >
        <template v-slot:[`item.sex`]="{ item }">
          <v-icon size="25" :color="item.sex == 'male' ? 'blue' : 'pink'">
            {{
              item.sex == "male" ? "mdi-gender-male" : "mdi-gender-female"
            }}</v-icon
          >
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip text="View" location="top">
            <template #activator="{ props }">
              <v-btn
                icon
                color="primary"
                variant="text"
                v-bind="props"
                @click="viewItem(item)"
              >
                <v-icon>mdi-eye</v-icon>
              </v-btn>
            </template>
          </v-tooltip>
          <!-- <v-tooltip text="Edit" location="top">
            <template #activator="{ props }">
              <v-btn
                icon
                color="primary"
                variant="text"
                v-bind="props"
                @click="editItem(item)"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </template>
          </v-tooltip> -->

          <!-- <v-tooltip text="Delete" location="top">
            <template #activator="{ props }">
              <v-btn
                icon
                color="error"
                variant="text"
                v-bind="props"
                @click="deleteItem(item)"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </template>
          </v-tooltip> -->
        </template>

        <template #no-data> No data found. </template>
      </v-data-table>
    </v-card>

    <!-- Dialogs -->
    <!-- <ProgramsDialog :data="uploadData" :action="action" /> -->
    <ProgramDialog :data="itemData" :action="action" />
    <v-dialog v-model="dialogConfirmDelete" max-width="500">
      <v-card>
        <v-card-title class="text-h6">Confirm Deletion</v-card-title>
        <v-card-text class="text-body-1">
          Are you sure you want to delete this item?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn variant="text" @click="dialogConfirmDelete = false"
            >Cancel</v-btn
          >
          <v-btn color="error" class="white--text" @click="confirmDelete"
            >Confirm</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <fade-away-message-component
      displayType="default"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :type="fadeAwayMessage.type"
    />
  </v-container>
</template>

<script>
import eventBus from "@/eventBus";
// import ProgramsDialog from "../Dialogs/Forms/ProgramsDialog.vue";
import ProgramDialog from "../Dialogs/Forms/ProgramDialog.vue";
export default {
  components: {
    // ProgramsDialog,
    ProgramDialog,
  },

  // props: {
  //   reloadTable: {
  //     type: Boolean,
  //     required: true,
  //   },
  // },
  data: () => ({
    search: "",
    headers: [
      { title: "Name", value: "name", align: "start" },
      { title: "Abbreviation", value: "abbr", align: "start" },
      { title: "Institute", value: "institute.name", align: "start" },

      {
        title: "Actions",
        value: "actions",
        align: "center",
        sortable: false,
        width: 200,
      },
    ],
    data: [],
    perPageChoices: [
      { text: "5", value: 5 },
      { text: "10", value: 10 },
      { text: "20", value: 20 },
      { text: "50", value: 50 },
      { text: "100", value: 100 },
      { text: "250", value: 250 },
      { text: "500", value: 500 },
    ],
    totalCount: 0,
    deleteData: null,
    itemData: null,
    uploadData: null,
    alerted: false,
    loading: false,
    options: {},
    action: null,
    paginationData: {},
    formdata: [],
    work_dates_menu: false,
    dialogConfirmDelete: false,
    fadeAwayMessage: {
      show: false,
      type: "success",
      header: "Successfully Deleted!",
      message: "",
      top: 10,
    },
  }),
  mounted() {
    this.initialize();
    eventBus.on("closeProgramDialog", () => {
      this.initialize();
    });
  },
  beforeUnmount() {
    eventBus.off("closeProgramDialog");
  },
  methods: {
    pagination(data) {
      this.paginationData = data;
    },
    initialize() {
      this.loading = true;
      this.axiosCall("/program", "GET").then((res) => {
        if (res) {
          this.data = res.data;
          this.loading = false;
        }
      });
    },
    addnew() {
      this.itemData = [{ id: null }];
      this.action = "Add";
    },
    upload() {
      this.uploadData = { id: null };
      this.action = "Add";
    },
    deleteItem(item) {
      console.log(item);
      this.alerted = true;
      // this.dialogConfirmDelete = true;
      // this.deleteData = item;
    },
    viewItem(item) {
      this.itemData = item;
      this.action = "View";
    },
    confirmDelete() {
      this.axiosCall("/request-type/" + this.deleteData.id, "DELETE").then(
        () => {
          this.fadeAwayMessage.show = true;
          this.itemData = null;
          this.initialize();
        },
      );
    },
  },
};
</script>
